module.exports = __webpack_public_path__ + "static/media/ocesalogo.2fd36014.png";